import React from 'react';
import AppIcon from './AppIcon';
import './ui.css';

/**
 * Horizontal "Popular Apps" card: icon, name, tagline, rating/installs, and a
 * View button. `onView` opens the app detail screen.
 */
export default function AppCard({ app, onView }) {
  const comingSoon = app.status === 'coming-soon';
  return (
    <div className="hive-appcard hive-rise">
      <AppIcon app={app} size={54} />
      <div className="hive-appcard-body" onClick={onView} role="button" tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onView && onView()}>
        <div className="hive-appcard-title-row">
          <span className="hive-card-title">{app.name}</span>
        </div>
        <p className="hive-appcard-tagline">{app.tagline}</p>
        {comingSoon && (
          <div className="hive-appcard-meta">
            <span className="hive-appcard-soon">Coming soon</span>
          </div>
        )}
      </div>
      <button type="button" className="hive-appcard-view hive-tap hive-focusable" onClick={onView}>
        View
      </button>
    </div>
  );
}
